import React, { useEffect } from 'react';
import Wrapper from '../components/layout/wrapper';
import Rslhome from '../components/home/rslhome';
// import RslHome from "./home/home_1";
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { fetchSeoByPage } from '../lib/seoHelper';
// import dotenv from 'dotenv';
// dotenv.config();

const MainRoot = ({ meta }) => {

  useEffect(() => {
    // Clear the console when the component is mounted
    console.clear();
  }, []);

  return (
    <Wrapper>
      <Rslhome meta={meta} />


      {/* <SignUp /> */}
    </Wrapper>
  );
};

export default MainRoot;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}